;(function (angular, _) {
  'use strict'

  class LedgerPage {
    // DI
    ledgerService
    // Locals
    ledgerErrors = []

    constructor (
      // Angular
      // Libs
      // Managers
      // Services
      LedgerService
      // Const
      // Resolved
    ) {
      this.ledgerService = LedgerService
    }

    exportLedger () {
      return this.ledgerService.getGeneralLedger((errors) => {
        this.ledgerErrors = errors.data
      })
    }

    onNewVat (vat) {
      this.ledgerErrors = this.ledgerErrors.filter((e) => {
        return e.type !== 'MISSING_VAT_ACCOUNT' && e.data.lineObject.VAT !== vat.value
      })
    }
  }

  LedgerPage.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    'LedgerService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.preferences')
    .component('ledgerPage', {
      bindings: {},
      templateUrl: '/app/modules/preferences/ledger/components/ledger-page/ledger-page.template.html',
      controller: LedgerPage
    })

})(window.angular, window._)
